import { Fragment, useEffect, useState, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import {
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    editProductTikTok,
    changeStatusProductTikTok,
    syncProductTikTokById,
    syncListPrice,
    changeVariantByCSV,
    syncDetailByShop,
    getProductDetail,
    findGroupProduct,
    startEditProduct,
} from "actions/productTikTokActions";
import { createProductById } from "actions/productActions";
import { getProductTemplate } from "actions/productTemplateAction";
import { getStaffs } from "actions/teamActions";
import { ReactTableDataGrid } from "components/Table";
import { ListDateType } from "helper/constant";
import { formatterCreateAt, convertTZ, FormatterStatus, sleep, findMinQuantity, daysSince } from "components/Function";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import EditProductTikTok from "./EditProductTikTok";
import _ from "lodash";
import Swal from "sweetalert2";
import { CSVLink } from "react-csv";
import Papa from "papaparse";
import { ModalSchedule, ModalAnalytic } from "./modal";
import ModalScheduleMulti from "./modalScheduleMulti";
import { productScheduleMulti } from "actions/productScheduleActions";
import { getShops } from "actions/shopActions";
import CustomHeader from "components/elements/customHeaderTable";
import ModalEditPrice from "./editProductPrice";
import ModalEditQty from "./editProductQty";
import ModalEditProductV2 from "./editProductV2";
import ModalInfomationProduct from "./modalInfomationProduct";
import ModalListPrice from "../modalListPrice";

const ProductList = ({
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    editProductTikTok,
    producttiktok,
    formatterCreateAt,
    getStaffs,
    FormatterStatus,
    productScheduleMulti,
    createProductById,
    changeStatusProductTikTok,
    findMinQuantity,
    getShops,
    shop,
    syncProductTikTokById,
    syncListPrice,
    user,
    changeVariantByCSV,
    daysSince,
    getProductTemplate,
    productTemplate,
    syncDetailByShop,
    getProductDetail,
    findGroupProduct,
    startEditProduct,
}) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [products_selected, setProductsSelected] = useState([]);
    const [infomationProduct, setInfomationProduct] = useState({});
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [sort_by, setSortBy] = useState("");
    const [sort_order, setSortOrder] = useState("");
    const [shops, setShops] = useState([]);
    const [listing_quality_tier, setlisting_quality_tier] = useState([]);
    const [loadingSync, setLoadingSync] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false);
    const [dataExport, setDataExport] = useState([]);
    const [editListPrice, setEditListPrice] = useState(false);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);
    const [productScheduleSelect, setProductScheduleSelect] = useState(null);
    const [productEditPrice, setProductEditPrice] = useState(null);
    const [productEditQty, setProductEditQty] = useState(null);
    const [productEdit, setProductEdit] = useState(null);
    const [productAnalytic, setProductAnalytic] = useState(null);
    const [productEditSuccess, setProductEditSuccess] = useState(0);
    const fileRef = useRef(null);
    const handleClick = () => fileRef.current?.click();

    const { t } = useTranslation();
    const { list, totalsize, isLoading } = producttiktok;

    const { list: templates } = productTemplate;

    const { list: list_shop } = shop;
    const { _id, email, role } = user.user;

    const listtemplate = [{ label: `All template`, value: "" }, { label: `Not in template`, value: "NO_SELECT" }].concat(templates?.map((v, i) => {
        return { label: `${v?.title}`, value: v?._id };
    }));

    const listshop = list_shop?.map((v, i) => {
        return { label: `${v?.name} (${v?.note}) - ${v?.region}`, value: v?._id };
    });

    const listQualityTier = [
        { value: "", label: "ALL" },
        { value: "GOOD", label: "GOOD" },
        { value: "FAIR", label: "FAIR" },
        { value: "POOR", label: "POOR" },
    ];

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "20",
            value: 20,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "300",
            value: 300,
        },
        {
            text: "All",
            value: totalsize || 20,
        },
    ];

    const onChangeShop = (e) => {
        var shops_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            shops: shops_tmp || [],
        }));
        setShops(shops_tmp);
    };

    const onChangeTier = (e) => {
        var tier_tmp = e.map((v, i) => {
            return v.value;
        });
        setFilter((prev) => ({
            ...prev,
            listing_quality_tier: tier_tmp || [],
        }));
        setlisting_quality_tier(tier_tmp);
    };

    useEffect(() => {
        getShops({ page: 1, sizeperpage: 1000 });
    }, [getShops]);

    useEffect(() => {
        getProductTemplate({ page: 1, sizeperpage: 5555 });
    }, [getProductTemplate]);

    useEffect(() => {
        if (Object.keys(filter).length) {
            getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter, sort_by, sort_order });
        }
    }, [getProductTikToks, page, sizePerPage, searchText, filter, sort_by, sort_order]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            var options = [
                { value: _id, label: email },
                ...(role !== 2 ? data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email + " - " + staff?.user?.name })) : [])
            ].filter(Boolean);
            setStaffs(options);
        });
    }, [getStaffs]);

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(10);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    const columns = [
        {
            field: "checkbox",
            headerName: "",
            cellClass: "centered-cell",
            headerCheckboxSelection: true,
            checkboxSelection: true,
            width: 50,
            sortable: false,
        },
        // {
        //     field: "_id",
        //     headerName: "No",
        //     editable: false,
        //     cellClass: "centered-cell",
        //     width: 50,
        //     cellRenderer: ({ rowIndex, value: cell, data: row }) => rowIndex + 1,
        //     comparator: () => 0,
        // },
        {
            field: "main_images",
            headerName: "Main Images",
            cellClass: "centered-cell overflow-visible",
            sortable: false,
            editable: false,
            width: 120,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <div className="symbol symbol-50px" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"View Images"} onClick={() => setInfomationProduct(row)}>
                        <img src={cell?.[0] || require("components/assets/media/misc/image.png")} alt="" className="mh-50px" />
                        {/* <ReactImageMagnify
                            {...{
                                smallImage: {
                                    alt: "",
                                    width: 50,
                                    height: 50,
                                    src: cell?.[0] || require("components/assets/media/misc/image.png"),
                                },
                                largeImage: {
                                    src: cell?.[0] || require("components/assets/media/misc/image.png"),
                                    width: 600,
                                    height: 600,
                                },
                                enlargedImageContainerDimensions: { width: "600%", height: "600%" },
                                enlargedImageContainerStyle: { zIndex: 99 },
                                className: "cursor-pointer",
                                enlargedImageContainerClassName: "al-zoom-img-cus",
                            }}
                        /> */}
                    </div>
                </>
            ),
        },
        {
            field: "title",
            headerName: t("Title"),
            width: 500,
            sortable: false,
            headerStyle: { width: "650px" },
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <div className="d-flex flex-stack">
                        <i className="ki-outline ki-copy ms-3" data-tooltip-id="my-tooltip"
                            data-tooltip-content={"Copy Title"} onClick={() => navigator.clipboard.writeText(cell)}></i><Link
                                to={"https://shop.tiktok.com/view/product/" + row.apiProductId}
                                className="d-flex flex-stack"
                                target="_blank"
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={cell}
                            >
                            <span className="text-primary fw-semibold fs-6 me-2">{cell.slice(0, 50)}...</span>{" "}
                            <i className="ki-outline ki-exit-right-corner fs-2"></i>
                        </Link>
                    </div>
                    <div className="d-flex flex-stack mb-2">
                        {row?.apiStatus !== "ACTIVATE" && row?.suspended_reason !== "" && row?.suspended_reason ? <span className="text-primary fw-semibold fs-6 me-2" data-tooltip-id="my-tooltip"
                            data-tooltip-content={row?.suspended_reason}><i className="ki-outline ki-question-2 fs-2"></i></span> : null}

                        {findMinQuantity(row?.skus) === 0 ? (
                            <FormatterStatus status={"Out Of Stock"} />
                        ) : findMinQuantity(row?.skus) < 5 ? (
                            <FormatterStatus status={"Low Stock"} />
                        ) : (
                            <FormatterStatus status={"In Stock"} />
                        )}
                        {/* <i className="ki-outline ki-picture fs-1 cursor-pointer" data-tooltip-id="my-tooltip"
                            data-tooltip-content={"View infomation"} onClick={() => setInfomationProduct(row)}></i> */}
                        <span className="text-muted fs-7">{row?.apiProductId}<i className="ki-outline ki-copy ms-3" data-tooltip-id="my-tooltip"
                            data-tooltip-content={"Copy ID"} onClick={() => navigator.clipboard.writeText(row.apiProductId)}></i></span>
                    </div>
                </>
            ),
        },
        // {
        //     field: "apiStatus",
        //     headerName: t("Status"),
        //     sortable: false,
        //     cellRenderer: ({ rowIndex, value: cell, data: row }) => <FormatterStatus status={cell} />,
        // },
        {
            field: "product_sku",
            headerName: t("SKU"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <Fragment>
                    <div className="text-muted fs-7" >{row?.skus?.[0]?.seller_sku || cell || "-"}<i className="ki-outline ki-copy ms-3" data-tooltip-id="my-tooltip"
                        data-tooltip-content={"Copy"} onClick={() => navigator.clipboard.writeText(row?.skus?.[0]?.seller_sku || cell || "")}></i></div>
                    <div>
                        {row?.listing_quality_tier === "GOOD" ? (
                            <>
                                <div className="d-flex align-items-end" data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Good"} >
                                    <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                                    <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                                    <div className="bullet w-15px h-8px rounded-2 bg-success me-3"></div>
                                </div>
                            </>
                        ) : row?.listing_quality_tier === "FAIR" ? (
                            <>

                                <div className="d-flex align-items-end" data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Fair"} >
                                    <div className="bullet w-15px h-8px rounded-2 bg-warning me-3"></div>
                                    <div className="bullet w-15px h-8px rounded-2 bg-warning me-3"></div>
                                </div>
                            </>
                        ) : row?.listing_quality_tier === "POOR" ? (
                            <>

                                <div className="d-flex align-items-end" data-tooltip-id="my-tooltip"
                                    data-tooltip-content={"Poor"} >
                                    <div className="bullet w-15px h-8px rounded-2 bg-danger me-3"></div>
                                </div>
                            </>
                        ) : (
                            ""
                        )}
                    </div>
                </Fragment>
            ),
        },
        {
            field: "templateId",
            headerName: t("Template"),
            editable: false,
            sort: true,
            width: 200,
            cellRenderer: ({ value: cell }) => <span data-tooltip-id="my-tooltip"
                data-tooltip-content={listtemplate?.find((v, i) => v?.value === cell)?.label || "NO_SELECT"}>{listtemplate?.find((v, i) => v?.value === cell)?.label || "NO_SELECT"}</span>,
        },
        {
            field: "orders_count",
            headerName: t("Performance"),
            sort: true,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <div>
                {`${cell || 0}`} items sold
                <div className="text-muted fs-6">Views: -</div>
            </div>,
            sortable: true,
            comparator: () => 0,
        },
        {
            field: "product",
            headerName: t("Link Ref"),
            sort: false,
            width: 150,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <Fragment>
                {cell?.ref_link ? <>
                    {cell?.ref_link.includes("amazon.")
                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                            alt="Logo"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content={t("Amazon")}
                            src={require("components/assets/media/site-logo/amazon.png")}
                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                        /></Link>
                        :
                        cell?.ref_link.includes("ebay.")
                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                alt="Logo"
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content={t("Ebay")}
                                src={require("components/assets/media/site-logo/ebay.png")}
                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                            /></Link>
                            :
                            cell?.ref_link.includes("1688.")
                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                    alt="Logo"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={t("1688")}
                                    src={require("components/assets/media/site-logo/1688.png")}
                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                /></Link>
                                :
                                cell?.ref_link.includes("academy.")
                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                        alt="Logo"
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={t("Academy")}
                                        src={require("components/assets/media/site-logo/academy.png")}
                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                    /></Link>
                                    :
                                    cell?.ref_link.includes("etsy.")
                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                            alt="Logo"
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content={t("Etsy")}
                                            src={require("components/assets/media/site-logo/etsy.png")}
                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                        /></Link>
                                        :
                                        cell?.ref_link.includes("google.")
                                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                alt="Logo"
                                                data-tooltip-id="my-tooltip"
                                                data-tooltip-content={t("Google Shopping")}
                                                src={require("components/assets/media/site-logo/google-shopping.png")}
                                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                            /></Link>
                                            :
                                            cell?.ref_link.includes("kohls.")
                                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                    alt="Logo"
                                                    data-tooltip-id="my-tooltip"
                                                    data-tooltip-content={t("Kohl's")}
                                                    src={require("components/assets/media/site-logo/kohl.png")}
                                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                /></Link>
                                                :
                                                cell?.ref_link.includes("macys.")
                                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                        alt="Logo"
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-content={t("Macy's")}
                                                        src={require("components/assets/media/site-logo/macys.png")}
                                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                    /></Link>
                                                    :
                                                    cell?.ref_link.includes("newbalance.")
                                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                            alt="Logo"
                                                            data-tooltip-id="my-tooltip"
                                                            data-tooltip-content={t("New Balance")}
                                                            src={require("components/assets/media/site-logo/new-balance.png")}
                                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                        /></Link>
                                                        :
                                                        cell?.ref_link.includes("pinterest.")
                                                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                alt="Logo"
                                                                data-tooltip-id="my-tooltip"
                                                                data-tooltip-content={t("Pinterest")}
                                                                src={require("components/assets/media/site-logo/pinterest.png")}
                                                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                            /></Link>
                                                            :
                                                            cell?.ref_link.includes("qvc.")
                                                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                    alt="Logo"
                                                                    data-tooltip-id="my-tooltip"
                                                                    data-tooltip-content={t("QVC")}
                                                                    src={require("components/assets/media/site-logo/qvc.jpg")}
                                                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                /></Link>
                                                                :
                                                                cell?.ref_link.includes("redbubble.")
                                                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                        alt="Logo"
                                                                        data-tooltip-id="my-tooltip"
                                                                        data-tooltip-content={t("Redbubble")}
                                                                        src={require("components/assets/media/site-logo/redbubble.png")}
                                                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                    /></Link>
                                                                    :
                                                                    cell?.ref_link.includes("sephora.")
                                                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                            alt="Logo"
                                                                            data-tooltip-id="my-tooltip"
                                                                            data-tooltip-content={t("Sephora")}
                                                                            src={require("components/assets/media/site-logo/sephora.png")}
                                                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                        /></Link>
                                                                        :
                                                                        cell?.ref_link.includes("shopee.")
                                                                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                alt="Logo"
                                                                                data-tooltip-id="my-tooltip"
                                                                                data-tooltip-content={t("Shopee")}
                                                                                src={require("components/assets/media/site-logo/shopee.png")}
                                                                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                            /></Link>
                                                                            :
                                                                            cell?.ref_link.includes("shopify.")
                                                                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                    alt="Logo"
                                                                                    data-tooltip-id="my-tooltip"
                                                                                    data-tooltip-content={t("Shopify")}
                                                                                    src={require("components/assets/media/site-logo/shopify.png")}
                                                                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                /></Link>
                                                                                :
                                                                                cell?.ref_link.includes("taobao.")
                                                                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                        alt="Logo"
                                                                                        data-tooltip-id="my-tooltip"
                                                                                        data-tooltip-content={t("Taobao")}
                                                                                        src={require("components/assets/media/site-logo/taobao.png")}
                                                                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                    /></Link>
                                                                                    :
                                                                                    cell?.ref_link.includes("tmall.")
                                                                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                            alt="Logo"
                                                                                            data-tooltip-id="my-tooltip"
                                                                                            data-tooltip-content={t("Tmall")}
                                                                                            src={require("components/assets/media/site-logo/taobao.png")}
                                                                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                        /></Link>
                                                                                        :
                                                                                        cell?.ref_link.includes("target.")
                                                                                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                alt="Logo"
                                                                                                data-tooltip-id="my-tooltip"
                                                                                                data-tooltip-content={t("Target")}
                                                                                                src={require("components/assets/media/site-logo/target.png")}
                                                                                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                            /></Link>
                                                                                            :
                                                                                            cell?.ref_link.includes("temu.")
                                                                                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                    alt="Logo"
                                                                                                    data-tooltip-id="my-tooltip"
                                                                                                    data-tooltip-content={t("Temu")}
                                                                                                    src={require("components/assets/media/site-logo/temu.png")}
                                                                                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                /></Link>
                                                                                                :
                                                                                                cell?.ref_link.includes("tiktok.")
                                                                                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                        alt="Logo"
                                                                                                        data-tooltip-id="my-tooltip"
                                                                                                        data-tooltip-content={t("Tiktok")}
                                                                                                        src={require("components/assets/media/site-logo/tiktok.png")}
                                                                                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                    /></Link>
                                                                                                    :
                                                                                                    cell?.ref_link.includes("walmart.")
                                                                                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                            alt="Logo"
                                                                                                            data-tooltip-id="my-tooltip"
                                                                                                            data-tooltip-content={t("Walmart")}
                                                                                                            src={require("components/assets/media/site-logo/walmart.png")}
                                                                                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                        /></Link>
                                                                                                        :
                                                                                                        cell?.ref_link.includes("woocommerce.")
                                                                                                            ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                                alt="Logo"
                                                                                                                data-tooltip-id="my-tooltip"
                                                                                                                data-tooltip-content={t("Woocommerce")}
                                                                                                                src={require("components/assets/media/site-logo/woo.png")}
                                                                                                                className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                            /></Link>
                                                                                                            :
                                                                                                            cell?.ref_link.includes("zazzle.")
                                                                                                                ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                                    alt="Logo"
                                                                                                                    data-tooltip-id="my-tooltip"
                                                                                                                    data-tooltip-content={t("Zazzle")}
                                                                                                                    src={require("components/assets/media/site-logo/zazzle.png")}
                                                                                                                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                                /></Link>
                                                                                                                :
                                                                                                                cell?.ref_link.includes("aliexpress.")
                                                                                                                    ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                                        alt="Logo"
                                                                                                                        data-tooltip-id="my-tooltip"
                                                                                                                        data-tooltip-content={t("Aliexpress")}
                                                                                                                        src={require("components/assets/media/site-logo/aliexpress.png")}
                                                                                                                        className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                                    /></Link>
                                                                                                                    :
                                                                                                                    cell?.ref_link.includes("shein.")
                                                                                                                        ? <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                                                                                                                            alt="Logo"
                                                                                                                            data-tooltip-id="my-tooltip"
                                                                                                                            data-tooltip-content={t("Shein")}
                                                                                                                            src={require("components/assets/media/site-logo/shein.png")}
                                                                                                                            className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                                                                                                                        /></Link>
                                                                                                                        : ""
                    }
                </> : <Link to={cell?.ref_link || "#"} target={cell?.ref_link ? "_blank" : "_self"}><img
                    alt="Logo"
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={t("Storage")}
                    src={require("components/assets/media/site-logo/4807934.png")}
                    className="ms-5 mb-5 shadow-lg bg-white rounded h-20px logo"
                /></Link>}
            </Fragment>,
            sortable: false,
            comparator: () => 0,
        },
        {
            field: "updated_at",
            headerName: t("Update At"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => <div>
                {formatterCreateAt(cell)}
                <div className="text-danger fs-7" data-tooltip-id="my-tooltip"
                    data-tooltip-content={`Created at: ${formatterCreateAt(row?.created_at)}`}><FormatterStatus status={row?.apiStatus} /> - {daysSince(row?.created_at)}</div>
            </div>,
        },
        {
            field: "createdBy",
            headerName: t("Created By"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => row?.createdBy?.email,
        },
        {
            field: "shops",
            headerName: t("Shop"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => `${cell?.name} (${cell?.note}) - ${cell?.region}`,
        },
        {
            field: "suspended_reason",
            headerName: t("Suspended Reason"),
            sortable: false,
        },
        {
            field: "-",
            headerName: t("Actions"),
            sortable: false,
            cellRenderer: ({ rowIndex, value: cell, data: row }) => (
                <>
                    <span
                        role="button"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit")}
                        onClick={() => setProductEdit(row)}
                    >
                        <i className="ki-outline ki-notepad-edit fs-2"></i>
                    </span>
                    <Link
                        role="button"
                        to="#"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit Price")}
                        onClick={async () => await getProductDetail(row?._id).then(async (p) => setProductEditPrice(p?.product))}
                    >
                        <i className="ki-outline ki-wallet fs-2"></i>
                    </Link>
                    <Link
                        role="button"
                        to="#"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Edit Quantity")}
                        onClick={async () => await getProductDetail(row?._id).then(async (p) => setProductEditQty(p?.product))}
                    >
                        <i className="ki-outline ki-abstract-26 fs-2"></i>
                    </Link>
                    <span
                        role="button"
                        className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2 d-none"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Sync Product")}
                        onClick={async () => {
                            await syncProductTikTokById(row._id);
                            getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                        }}
                    >
                        <i className="bi bi-arrow-repeat fs-2"></i>
                    </span>

                    <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Analytic"
                        onClick={() => setProductAnalytic(row.apiProductId)}
                    >
                        <i className="ki-outline ki-outline ki-ranking fs-2"></i>
                    </button>
                    {/* <button
                        className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content={t("Delete")}
                        onClick={() =>
                            getCheckProductTikTok([row._id]).then((data) => {
                                if (data) getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter, sort_by, sort_order });
                            })
                        }
                    >
                        <i className="ki-outline ki-trash fs-2"></i>
                    </button> */}
                    {/* <button onClick={() => {
                        setProductScheduleSelect({
                            ...row,
                            page, sizeperpage: sizePerPage, search: searchText, filter
                        })
                    }} className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm me-2" data-tooltip-id="my-tooltip" data-tooltip-content={t("Schedule")}>
                        <i className="ki-outline ki-calendar-add fs-2"></i>
                    </button> */}
                </>
            ),
        },
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(10);
            setSearchText(searchText);
        } else {
            setPage(page);
            setSizePerPage(sizePerPage);
        }
    };

    const handleFilter = (e) => {
        setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(10);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };
    const onClickDeleteProduct = async () => {
        await findGroupProduct(products_selected, setLoadingPage).then(async (f) => {
            if (f?.length > 0) {
                setProductEditSuccess(0);
                let count = 0;
                await Promise.all(
                    f?.map(async (appData) => {
                        return new Promise(async (resolve2, reject2) => {
                            var listShopEdit = appData?.shops;
                            var app = appData?.app?._id?.toString();
                            for (var i = 0; i < listShopEdit?.length; i++) {
                                var listProducts = listShopEdit[i]?.products;
                                var shopData = listShopEdit[i]?._id?.toString();
                                var chunkProducts = _.chunk(listProducts, 20);
                                for (var j = 0; j < chunkProducts?.length; j++) {
                                    var listProductsChunk = chunkProducts[j];
                                    await deleteProductTikTok({ appId: app, shopId: shopData, products: listProductsChunk }).then(async (ed) => {
                                        count = count + listProductsChunk?.length;
                                        setProductEditSuccess(count);
                                        await sleep(2500);
                                    })
                                }
                            }
                            resolve2();
                        });
                    })
                );
                setLoadingPage(false)
                return Swal.fire(t("Success"), t("Delete Done!"), "success");
            }

            setLoadingPage(false)
        })
    };

    const onClickChangeStatusProduct = async () => {
        await findGroupProduct(products_selected, setLoadingPage).then(async (f) => {
            if (f?.length > 0) {
                setProductEditSuccess(0);
                let count = 0;
                await Promise.all(
                    f?.map(async (appData) => {
                        return new Promise(async (resolve2, reject2) => {
                            var listShopEdit = appData?.shops;
                            var app = appData?.app?._id?.toString();
                            for (var i = 0; i < listShopEdit?.length; i++) {
                                var listProducts = listShopEdit[i]?.products;
                                var shopData = listShopEdit[i]?._id?.toString();
                                await changeStatusProductTikTok({ appId: app, shopId: shopData, products: listProducts }).then(async (ed) => {
                                    count = count + listProducts?.length;
                                    setProductEditSuccess(count);
                                    await sleep(2500);
                                })
                            }
                            resolve2();
                        });
                    })
                );
                setLoadingPage(false)
                return Swal.fire(t("Success"), t("Change Done!"), "success");
            }

            setLoadingPage(false)
        })
    };

    const onClickSyncListPrice = async (amount, dataListPrice) => {
        await getCheckProductTikTok(products_selected, setLoadingPage).then(async (data) => {
            const groupApp = _.groupBy(data?.filterProduct, "appId");
            const mapSyncPrice = Object.values(groupApp);
            var totalSuccess = 0;
            var totalFail = 0;
            setLoadingPage(true);
            await Promise.all(
                mapSyncPrice.map(async (data_app, i) => {
                    await sleep(i * 500);
                    return new Promise(async (resolve2, reject2) => {
                        for (var i = 0; i < data_app.length; i++) {
                            var data_sync = data_app[i];
                            data_sync.skus = data_sync.skus.map((sku) => {
                                let list_price;
                                if (dataListPrice.type === "plus" && +dataListPrice.extValue) {
                                    list_price = {
                                        amount: (+dataListPrice?.extValue + +sku?.price).toString(),
                                        currency: "USD",
                                    };
                                }

                                if (dataListPrice?.type === "percent" && dataListPrice?.extValue) {
                                    list_price = {
                                        amount: (+sku?.price + (+sku?.price * +dataListPrice?.extValue) / 100).toFixed(
                                            2
                                        ),
                                        currency: "USD",
                                    };
                                }

                                if (dataListPrice?.type === "fixed" && +dataListPrice?.amount) {
                                    list_price = {
                                        amount: dataListPrice?.amount?.toString(),
                                        currency: "USD",
                                    };
                                }
                                return {
                                    ...sku,
                                    list_price,
                                };
                            });

                            await syncListPrice({ data_sync }).then(async (a) => {
                                if (a === 200) {
                                    totalSuccess++;
                                } else {
                                    totalFail++;
                                }
                                resolve2("ok");
                            });
                        }
                    });
                })
            ).then(async (dat) => {
                setLoadingPage(true);
                if (data)
                    await getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(
                    t("Success"),
                    t(`Sync ${totalSuccess} OK - ${totalFail} Can on going Flash Sale!`),
                    "success"
                );
                setLoadingPage(false);
            });
            setLoadingPage(false);
        });
    };

    const onClickEditProduct = (type) => {
        getCheckProductTikTok(products_selected, setLoadingPage).then((data) => {
            const groupShop = _.groupBy(data?.filterProduct, "shopId");
            const mapDelete = Object.entries(groupShop);
            Promise.all(
                mapDelete.map(async (data_shop, i) => {
                    return new Promise(async (resolve2, reject2) => {
                        const shopId = data_shop?.[0];
                        const key_data = data_shop?.[1];
                        Promise.all(
                            key_data.map(async (productId, i) => {
                                await sleep(i * 500);
                                return new Promise(async (resolve, reject) => {
                                    await editProductTikTok({
                                        productId,
                                        shopId,
                                        type,
                                    }).then(async (a) => {
                                        resolve("ok");
                                    });
                                });
                            })
                        ).then(async (dat) => {
                            resolve2("ok");
                        });
                    });
                })
            ).then(async (dat) => {
                if (data)
                    getProductTikToks({
                        page,
                        sizeperpage: sizePerPage,
                        search: searchText,
                        filter,
                        sort_by,
                        sort_order,
                    });
                Swal.fire(t("Success"), t("Edited success"), "success");
            });
        });
    };

    // const handleDeleteProduct = async (data) => {
    //     await deleteProductTikTok2({ data }).then((data_) => {
    //         return Swal.fire(t("Success"), t("Delete Success!"), "success");
    //     });
    // };

    const handleSchedule = async (data) => {
        var products = list
            ?.filter((v, i) => products_selected.includes(v._id.toString()))
            ?.map((v, i) => {
                var product = {
                    _id: v?._id?.toString(),
                    title: v?.title,
                    main_images: v?.main_images || "",
                };
                return product;
            });
        await productScheduleMulti({ ...data, products, type: "tiktok" }, setLoadingPage);
    };

    const handleEditProduct = async (data) => {
        if (products_selected?.length === 0) return Swal.fire(t("Error"), t("Please select products!"), "error");
        if (products_selected?.length > 0) {
            setProductEditSuccess(0);
            let count = 0;
            if (data?.option && data?.option === "template_setting") {
                await startEditProduct({ appId: "template_setting", shopId: "template_setting", product: products_selected, ...data }).then(async (ed) => {
                    count = count + products_selected?.length;
                    setProductEditSuccess(count);
                    await sleep(500);
                    setLoadingPage(false)
                    return Swal.fire(t("Success"), t("Edit Done!"), "success");
                })
            } else {
                await findGroupProduct(products_selected, setLoadingPage).then(async (f) => {
                    if (f?.length > 0) {
                        await Promise.all(
                            f?.map(async (appData) => {
                                return new Promise(async (resolve2, reject2) => {
                                    var listShopEdit = appData?.shops;
                                    var app = appData?.app?._id?.toString();
                                    for (var i = 0; i < listShopEdit?.length; i++) {
                                        var listProducts = listShopEdit[i]?.products;
                                        var shopData = listShopEdit[i]?._id?.toString();
                                        for (var j = 0; j < listProducts?.length; j++) {
                                            var productSelect = listProducts[j];
                                            await startEditProduct({ appId: app, shopId: shopData, product: productSelect, ...data }).then(async (ed) => {
                                                count++;
                                                setProductEditSuccess(count);
                                                await sleep(500);
                                            })
                                        }
                                    }
                                    resolve2();
                                });
                            })
                        );
                        setLoadingPage(false)
                        return Swal.fire(t("Success"), t("Edit Done!"), "success");
                    }

                    setLoadingPage(false)
                })
            }

        }
    };

    const onClickExportData = async () => {
        let save_data_export = [];
        save_data_export = list
            ?.filter((v, i) => products_selected?.includes(v._id))
            ?.map((v, i) => {
                return {
                    title: v.title,
                    productId: v.apiProductId,
                    sku: v?.skus?.[0]?.seller_sku || v.product_sku || "",
                    image1: v?.main_images?.[0] || "",
                    image2: v?.main_images?.[1] || "",
                    image3: v?.main_images?.[2] || "",
                    image4: v?.main_images?.[3] || "",
                    image5: v?.main_images?.[4] || "",
                    image6: v?.main_images?.[5] || "",
                    image7: v?.main_images?.[6] || "",
                    image8: v?.main_images?.[7] || "",
                    image9: v?.main_images?.[8] || "",
                };
            });
        setDataExport(save_data_export);
        setInitiateDownload(true);
        await sleep(2500);
        setLoadingPage(false);
    };

    const onClickCreateProductById = () => {
        // (true);
        createProductById(products_selected, setLoadingPage).then((data) => {
            if (data) getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
        });
    };

    const removeSelect = (arr, value) => {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    };

    const onSelectionChanged = (data) => {
        if (data.api) {
            const ids = data.api.getSelectedRows().map((d) => d._id);
            setProductsSelected(ids);
            if (ids.length !== 0) {
                setLoadingSync(false);
            }
            if (ids.length === 0) {
                setLoadingSync(true);
            }
        }
    };

    const onSelect = (row, isSelect) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp.push(row._id);
        } else {
            products_selected_tmp = removeSelect(products_selected_tmp, row._id);
        }
        var new_arr = JSON.stringify(products_selected_tmp);
        setProductsSelected(JSON.parse(new_arr));
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const onSelectAll = (isSelect, row) => {
        var products_selected_tmp = products_selected;
        if (isSelect) {
            products_selected_tmp = row.map((v, i) => v._id);
        } else {
            products_selected_tmp = [];
        }
        setProductsSelected(products_selected_tmp);
        if (products_selected_tmp.length !== 0) {
            setLoadingSync(false);
        }
        if (products_selected_tmp.length === 0) {
            setLoadingSync(true);
        }
    };

    const handleFileChange = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        Papa.parse(file, {
            header: true,
            skipEmptyLines: "greedy",
            transformHeader: (h) => (h || "").trim(),
            complete: (results) => {
                const { data, errors, meta } = results;

                if (errors?.length) {
                    Swal.fire("Error", "CSV parse error. Please check the file.", "error");
                    e.target.value = "";
                    return;
                }

                if (!data || data.length === 0) {
                    Swal.fire("Error", "CSV is empty.", "error");
                    e.target.value = "";
                    return;
                }

                const headers = (meta?.fields || []).map((h) => h.trim()).filter(Boolean);

                // Bắt buộc phải có price & quantity
                const mustHave = ["price", "quantity"];
                const missing = mustHave.filter((h) => !headers.includes(h));
                if (missing.length) {
                    Swal.fire("Error", `Missing column(s): ${missing.join(", ")}`, "error");
                    e.target.value = "";
                    return;
                }

                // Option keys (linh động theo CSV header, loại bỏ price/quantity)
                const variantKeys = headers.filter((h) => !mustHave.includes(h)).slice(0, 3);

                if (variantKeys.length === 0) {
                    Swal.fire("Error", "Please done variant to save", "error");
                    e.target.value = "";
                    return;
                }

                // Build lại optionsVariants
                const optionsVariants = variantKeys.map((k) => ({
                    key: k,
                    value: Array.from(new Set(data.map((r) => r[k]).filter(Boolean))),
                    type: "custom",
                }));

                // Build lại skus
                const skus = data.map((row, idx) => {
                    const sku = { _id: idx, thumbnail: "", seller_sku: "" };
                    variantKeys.forEach((k) => (sku[k] = (row[k] ?? "").trim()));
                    sku.price = (row.price ?? "").trim();
                    sku.quantity = (row.quantity ?? "").trim();
                    return sku;
                })?.filter((sku) => +sku.quantity > 0 && +sku.price > 0);

                // Callback thay thế state cha
                // setFormData((prev) => ({ ...prev, skus, optionsVariants })); // Cập nhật skus để hiển thị bảng
                // setOptionsVariants(optionsVariants); // Cập nhật optionsVariants để hiển thị đúng tên cột

                // Swal.fire("Success", "Import CSV successfully!", "success");
                // reset input để lần sau có thể chọn lại cùng file
                e.target.value = "";
                if (products_selected?.length > 0) {
                    changeVariantByCSV({ skus, optionsVariants, products_selected }, setLoadingPage)
                }
            },
            error: () => {
                Swal.fire("Error", "Failed to read CSV file.", "error");
                e.target.value = "";
            },
        });
    };

    const handleSyncDetail = () => {
        if (products_selected?.length > 0) {
            syncDetailByShop(products_selected, setLoadingPage)
        }
    };

    const groupButton = () => {
        return (
            <div>
                <div className="mb-5 d-flex flex-md-row flex-column gap-2">
                    <button
                        onClick={() => {
                            onClickDeleteProduct();
                        }}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-danger btn-sm me-2 mb-2"
                    >
                        <i className="ki-outline ki-cross-circle fs-2"></i> {t("Delete Product")}
                    </button>
                    {/* <ModalDeleteProductTikTok
                        onSubmit={(data) => {
                            handleDeleteProduct(data);
                        }}
                    /> */}
                    {/* <button
                        disabled={loadingSync}
                        onClick={() => {
                            onClickEditProduct("CoTik.App");
                        }}
                        type="button"
                        className="btn btn-info btn-sm me-2 mb-2"
                        hidden={true}
                    >
                        <i className="ki-outline ki-shield-tick fs-2"></i> {t("As Draft To Listing")}
                    </button> */}
                    <button
                        onClick={() => {
                            onClickChangeStatusProduct();
                        }}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-warning btn-sm me-2 mb-2"
                    >
                        <i className="ki-outline ki-switch fs-2"></i> {t("Change Status")}
                    </button>
                    <ModalScheduleMulti
                        onSubmit={handleSchedule}
                        shops={listshop}
                        products_selected={products_selected?.length}
                    />
                    <button
                        onClick={() => {
                            onClickCreateProductById();
                        }}
                        type="button"
                        className="btn btn-primary btn-sm me-2 mb-2"
                    >
                        <i className="bi bi-plus fs-2"></i> {t("Create Product System")}
                    </button>
                    <button type="button" onClick={handleClick} className="btn btn-info btn-sm me-2 mb-2">
                        <i className="ki-outline ki-arrows-circle fs-2"></i> Change Variants by CSV
                    </button>
                    <EditProductTikTok
                        onSubmit={handleEditProduct}
                        templates={listtemplate}
                        products_selected={products_selected}
                    />
                    <input
                        ref={fileRef}
                        type="file"
                        accept=".csv,text/csv"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                    />
                    <br />
                    <button
                        onClick={() => handleSyncDetail(true)}
                        // onClick={() => setEditListPrice(true)}
                        disabled={loadingSync}
                        type="button"
                        className="btn btn-warning btn-sm me-2 mb-2"
                    >
                        <i className="bi bi-arrow-repeat fs-2"></i> {t("Sync Detail")}
                        {/* <i className="bi bi-arrow-repeat fs-2"></i> {t("Sync List Price")} */}
                    </button>
                    <button onClick={onClickExportData} className="btn btn-sm btn-success me-2 mb-2">
                        <i className="ki-outline ki-exit-down"></i>Export
                    </button>
                    <CSVLink filename={"data_tiktok_" + dataExport.length + "_products.csv"} data={dataExport}>
                        <span ref={btnRef} />
                    </CSVLink>
                </div>
                <div className="mb-5 d-flex flex-md-row flex-column justify-content-start w-100 gap-3">
                    <Select
                        isClearable
                        isMulti
                        name="shop"
                        options={listshop}
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        value={listshop.filter(({ value }) => shops.includes(value))}
                        onChange={(e) => {
                            onChangeShop(e);
                        }}
                        placeholder={t("Select a shop ... ")}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <select
                        className="form-select basic-multi-select al-custom-select-search-variants al-filter-table"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="currency"
                        name="status"
                        onChange={handleFilter}
                    >
                        <option value="ACTIVATE">ACTIVATE</option>
                        <option value="DRAFT">DRAFT</option>
                        <option value="PENDING">PENDING</option>
                        <option value="FAILED">FAILED</option>
                        <option value="SELLER_DEACTIVATED">SELLER_DEACTIVATED</option>
                        <option value="PLATFORM_DEACTIVATED">PLATFORM_DEACTIVATED</option>
                        <option value="FREEZE">FREEZE</option>
                        <option value="DELETED">DELETED</option>
                        <option value="AWAITING">AWAITING</option>
                        <option value="">ALL</option>
                    </select>
                    <Select
                        isClearable
                        isMulti
                        name="listing_quality_tier"
                        options={listQualityTier}
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        value={listQualityTier.filter(({ value }) => listing_quality_tier.includes(value))}
                        onChange={(e) => {
                            onChangeTier(e);
                        }}
                        placeholder={t("Select a tier ... ")}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <SelectBox
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        options={staffs}
                        name="filter_staff"
                        placeholder="Select Staff"
                        value={filter.staff || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                staff: data.value || "",
                            }));
                            setPage(1);
                        }}
                    />
                    <Select
                        isClearable
                        name="filter_templateId"
                        options={listtemplate}
                        value={listtemplate?.filter(({ value }) => value === filter?.templateId)}
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                templateId: data?.value || "",
                            }));
                            setPage(1);
                        }}
                        placeholder={t(`Select a template ... `)}
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    <SelectBox
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        options={[{ label: "Updated At", value: "updated_at" }, { label: "Created At", value: "created_at" }]}
                        name="filter_option_date"
                        placeholder="Select Type Date"
                        value={filter.option_date || ""}
                        onChange={(data) => {
                            setFilter((prev) => ({
                                ...prev,
                                option_date: data.value || "updated_at",
                            }));
                            setPage(1);
                        }}
                    />
                    <Select
                        name="dateType"
                        options={ListDateType}
                        className="basic-multi-select al-custom-select-search-variants me-2 mb-0 al-filter-table"
                        classNamePrefix="select"
                        value={ListDateType.filter(({ value }) => value === dateType)}
                        onChange={(e) => {
                            setDateType(e?.value || "");
                        }}
                        placeholder="Select a date ... "
                        theme={(theme) => ({
                            ...theme,
                            spacing: {
                                ...theme.spacing,
                                controlHeight: "100%",
                                controlWidth: "200px",
                            },
                        })}
                    />
                    {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                        <DateRangePicker
                            onCallback={handleEventDate}
                            initialSettings={{
                                startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                showDropdowns: true,
                                locale: { format: "DD/MM/YYYY" },
                            }}
                        >
                            <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                        </DateRangePicker>
                    ) : (
                        ""
                    )}
                </div>
                <span className="h3">Total: {totalsize} Products</span>
            </div>
        );
    };

    const onTableChanged = ({ page, limit, text }) => {
        if (limit) setSizePerPage(limit);
        if (page) setPage(page);
        if (typeof text === "string") setSearchText(text);
    };

    const defaultColDef = useMemo(
        () => ({
            wrapText: true,
            autoHeight: true,
            wrapHeaderText: true,
            autoHeaderHeight: true,
        }),
        []
    );

    const components = useMemo(() => {
        return {
            agColumnHeader: CustomHeader,
        };
    }, []);

    const onSortChanged = (e) => {
        if (e.source === "uiColumnSorted") {
            console.log(e.api.setSuppressAnimations);
            const sortedColumns = e.api.getColumnState().filter((col) => col.sort);
            console.log(sortedColumns?.[0]?.colId, sortedColumns?.[0]?.sort);

            setSortBy(sortedColumns?.[0]?.colId);
            setSortOrder(sortedColumns?.[0]?.sort || "desc");
        }
    };

    return (
        <>
            <div className="card min-w-full">
                <Loading isLoading={isLoading} />
                <Loading isLoading={loadingPage} totalSync={products_selected?.length || 0} pageSync={productEditSuccess || 0} />

                <div className="card-body">
                    <div className="al-variants-table al-max-height-table-cus">
                        {/* <ReactTable
                            columns={columns}
                            data={list || []}
                            groupButton={groupButton}
                            handleTableChange={handleTableChange}
                            page={page}
                            sizePerPage={sizePerPage}
                            totalSize={totalSize}
                            alClassName="table-layout-inherit"
                            sizePerPageList={sizePerPageList}
                            isSelectRow={true}
                            selectRow={selectRow}
                        /> */}

                        <ReactTableDataGrid
                            tableName="productsTiktokTable"
                            idProperty="_id"
                            columns={columns}
                            rowData={list}
                            defaultColDef={defaultColDef}
                            gridOptions={{
                                reactiveCustomComponents: true,
                            }}
                            paginationPageSize={sizePerPage}
                            totalSize={totalSize}
                            onTableChanged={onTableChanged}
                            emptyText={t("No data!")}
                            rowSelection="multiple"
                            onSelectionChanged={onSelectionChanged}
                            sizePerPageList={sizePerPageList}
                            groupButton={groupButton}
                            onSortChanged={onSortChanged}
                            components={components}
                        />
                    </div>
                </div>
            </div>
            <ModalSchedule
                data={productScheduleSelect}
                shops={listshop}
                onClose={() => setProductScheduleSelect(null)}
                onSubmit={() => {
                    // getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditPrice
                isOpen={Boolean(productEditPrice)}
                onClose={() => setProductEditPrice(null)}
                product={productEditPrice}
                onSubmit={() => {
                    // getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditQty
                isOpen={Boolean(productEditQty)}
                onClose={() => setProductEditQty(null)}
                product={productEditQty}
                onSubmit={() => {
                    // getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalEditProductV2
                isOpen={Boolean(productEdit)}
                onClose={() => setProductEdit(null)}
                product={productEdit}
                onSubmit={() => {
                    // getProductTikToks({ page, sizeperpage: sizePerPage, search: searchText, filter });
                }}
            />
            <ModalAnalytic productId={productAnalytic} onClose={() => setProductAnalytic(null)} />
            <ModalListPrice
                isOpen={Boolean(editListPrice)}
                onClose={() => setEditListPrice(false)}
                onSubmit={onClickSyncListPrice}
            />
            <ModalInfomationProduct product={infomationProduct} />
        </>
    );
};

const mapStateToProps = ({ producttiktok, shop, user, productTemplate }) => ({ producttiktok, shop, user, productTemplate });
const mapDispatchToProps = {
    getProductTikToks,
    getCheckProductTikTok,
    deleteProductTikTok,
    formatterCreateAt,
    getStaffs,
    findMinQuantity,
    FormatterStatus,
    editProductTikTok,
    productScheduleMulti,
    createProductById,
    changeStatusProductTikTok,
    getShops,
    syncProductTikTokById,
    syncListPrice,
    changeVariantByCSV,
    daysSince,
    getProductTemplate,
    syncDetailByShop,
    getProductDetail,
    findGroupProduct,
    startEditProduct,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);
